import React from 'react';

const Hero = () => {
    return (
        <div className="relative w-full h-[400px] sm:h-[500px] overflow-hidden">
            {/* Background Image Container */}
            <div className="absolute inset-0">
                <img
                    className="w-full h-full object-cover"
                    src="https://images.unsplash.com/photo-1544148103-0773bf10d330?q=80&w=2070&auto=format&fit=crop"
                    alt="Authentic Ethiopian Cuisine"
                />
                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" />
            </div>

            {/* Content Container */}
            <div className="relative h-full flex flex-col items-center justify-center text-center px-4">
                <div className="animate-fade-in-up">
                    <span className="px-3 py-1 text-sm font-semibold text-amber-500 bg-amber-500/10 backdrop-blur-md rounded-full mb-4 inline-block border border-amber-500/20">
                        Welcome to
                    </span>
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-tight drop-shadow-lg">
                        Addis Taim
                    </h1>
                    <p className="text-lg sm:text-xl text-gray-200 max-w-2xl mx-auto mb-8 font-light drop-shadow-md">
                        Experience the rich flavors and authentic traditions of Ethiopian cuisine, crafted with love and served with warmth.
                    </p>

                    <a
                        href="https://feedback.addistaimrestaurant.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="group relative inline-flex items-center justify-center px-8 py-3.5 text-base font-bold text-white bg-amber-600 rounded-full overflow-hidden transition-all duration-300 hover:bg-amber-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 focus:ring-offset-gray-900 shadow-[0_0_20px_rgba(217,119,6,0.3)] hover:shadow-[0_0_25px_rgba(217,119,6,0.5)] transform hover:-translate-y-0.5"
                    >
                        <span className="mr-2">Give Feedback</span>
                        <svg className="w-5 h-5 transform transition-transform group-hover:translate-y-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Hero;
